function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "type", "tag", "inline", "ariaHidden", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'classnames';
import "./bodyText.css";
export var BodyText = function BodyText(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'div' : _ref$tag,
    inline = _ref.inline,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var BodyTag = inline ? 'span' : tag;
  React.useEffect(function () {
    if (inline && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('The `inline` prop on BodyText is deprecated and will be removed in the next major release. Please use the `tag` prop instead. See https://designsystem.lmig.com/components/form/field-group/code for documentation.');
    }
  }, [inline]);
  return /*#__PURE__*/React.createElement(BodyTag, _extends({
    id: id,
    className: classNames('lm-Body', _defineProperty({}, "lm-Body--".concat(type), type !== 'default'), className),
    "aria-hidden": ariaHidden ? 'true' : undefined
  }, otherProps), children);
};
BodyText.propTypes = {
  /** Add an optional ID to the element with the class`lm-Body`. */id: _pt.string,
  /** Add custom classes to the element with the class `lm-Body`. */className: _pt.string,
  /** Set the style and size of the content within BodyText.
     *  @default 'default'
     */
  type: _pt.oneOf(['default', 'default-medium', 'article', 'article-medium', 'lead', 'lead-medium']),
  /** Specify the HTML tag if it should be different from the default wrapping `div`.
     * @default 'div'
     */
  tag: _pt.oneOf(['div', 'p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /** DEPRECATED: Use `tag` instead. If true, this will wrap the content in a span instead of a div. */inline: _pt.bool,
  /** Hide the element from screen readers.
     * @default false
     */
  ariaHidden: _pt.bool,
  /** Body content is not automatically wrapped in semantic tags.
     * Pass your content wrapped in the appropriate <p> or other text tags.
     * Children are rendered in the element with the class `lm-Body`.
     */
  children: _pt.node
};